/* eslint-disable react/no-danger */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import formValueSelector from "redux-form/lib/formValueSelector";
import Immutable from "immutable";
import { createSelector } from "reselect";
import isEqual from "lodash/isEqual";

import { price } from "../../../lib/utils";
import SchemaField from "../../../component/SchemaField";
import { CARD_ID_RIBBON } from "../../../lib/constants";

// const RANDY_BUGGER = () =>
// ({ backgroundColor: `rgba(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255}, 0.4)` });

export const getCardTypeLabelText = (isMixedMourning, isMourning) => {
  if (isMixedMourning) {
    return "choosecardribboncardtext";
  }
  if (isMourning) {
    return "choosecardribbontext";
  }
  return "choosecardtext";
};

export const getCardTextLabel = (isMixedMourning, isMourning) => {
  if (isMixedMourning) {
    return "cardribboncardtext";
  }
  if (isMourning) {
    return "cardtextmourning";
  }
  return "cardtext";
};

/**
 * CardDetails
 */
class CardDetails extends Component {
  static propTypes = {
    schema: PropTypes.instanceOf(Immutable.Map).isRequired,
    t: PropTypes.func.isRequired,
    ctxIdx: PropTypes.number.isRequired,
    selectedCardId: PropTypes.number,
    cardText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    cardTextMaxLength: PropTypes.number,
    ribbonTextMaxLength: PropTypes.number,
    isMourning: PropTypes.bool,
    isMixedMourning: PropTypes.bool
  };

  static defaultProps = {
    cardText: "",
    cardTextMaxLength: 230,
    ribbonTextMaxLength: 50,
    selectedCardId: -1,
    isMourning: false,
    isMixedMourning: false
  };

  shouldComponentUpdate(nextProps) {
    // for some reason this does not work in the connect() "areMergedPropsEqual" option
    return !isEqual(this.props, nextProps);
  }

  ribbonLeftMaxSubstring = v => (v && v.length ? v.substring(0, this.props.ribbonTextMaxLength) : v);

  renderRibbon() {
    const { schema, cardText, ctxIdx, t } = this.props;
    const idPrefix = `form-control-recipients-${ctxIdx}-`;
    const namePrefix = `recipients[${ctxIdx}].`;

    const ribbonLeftLength = this.props.ribbonTextMaxLength - ((cardText.left && cardText.left.length) || 0);
    const ribbonRightLength = this.props.ribbonTextMaxLength - ((cardText.right && cardText.right.length) || 0);

    // maxChars
    return (
      <div>
        <h3 className="mt-2 mr-1">
          {t("text")} {t("Ribbon")} 1
        </h3>
        <label
          htmlFor={`${idPrefix}card-text-left`}
          dangerouslySetInnerHTML={{
            __html: t("cardTextCounter", {
              maxLength: ribbonLeftLength,
              escapeInterpolation: false
            })
          }}
        />
        <SchemaField
          name={`${namePrefix}card.text.left`}
          schema={schema}
          rows={3}
          inputType="textarea"
          label={false}
          format={this.ribbonLeftMaxSubstring}
          parse={this.ribbonLeftMaxSubstring}
          normalize={this.ribbonLeftMaxSubstring}
        />
        {ribbonLeftLength <= 0 && <div>{t("maxChars")}</div>}
        <h3 className="mt-2 mr-1">
          {t("text")} {t("Ribbon")} 2
        </h3>
        <label
          htmlFor={`${idPrefix}card-text-right`}
          dangerouslySetInnerHTML={{
            __html: t("cardTextCounter", {
              maxLength: ribbonRightLength,
              escapeInterpolation: false
            })
          }}
        />
        <SchemaField
          name={`${namePrefix}card.text.right`}
          schema={schema}
          rows={3}
          inputType="textarea"
          label={false}
          parse={null}
        />
        {ribbonRightLength <= 0 && <div>{t("maxChars")}</div>}
      </div>
    );
  }

  renderCard() {
    const { schema, selectedCardId, ctxIdx, isMourning, isMixedMourning, t } = this.props;
    const idPrefix = `form-control-recipients-${ctxIdx}-`;
    const namePrefix = `recipients[${ctxIdx}].`;
    const isRibbon = selectedCardId === CARD_ID_RIBBON;

    const cardTextLength = this.props.cardTextMaxLength - (this.props.cardText.length || 0);
    const hasMaxCharError = cardTextLength <= 0;
    return (
      <div>
        <div className="Cart__Step__Header mt-3">{t(getCardTypeLabelText(isMixedMourning, isMourning))}</div>

        <SchemaField name={`${namePrefix}card.type`} schema={schema} label={false} />

        {this.props.selectedCardId !== 0 && isRibbon && this.renderRibbon()}

        {this.props.selectedCardId !== 0 && !isRibbon && (
          <div className={hasMaxCharError ? "has-warning" : ""}>
            <h3>{t(getCardTextLabel(isMixedMourning, isMourning))}</h3>
            <label
              htmlFor={`${idPrefix}card-text`}
              dangerouslySetInnerHTML={{
                __html: t("cardTextCounter", {
                  maxLength: cardTextLength,
                  escapeInterpolation: false
                })
              }}
            />
            <SchemaField
              name={`${namePrefix}card.text`}
              schema={schema}
              rows={7}
              inputType="textarea"
              label={false}
              parse={null}
            />
            {hasMaxCharError && (
              <div className="warning-feedback">
                <i className="fa fa-info-circle mr-1" />
                {t("maxChars")}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  render() {
    return <div className="Cart__CardDetails">{this.renderCard()}</div>;
  }
}

const formSelector = formValueSelector("cart");

const EMPTY_LIST = Immutable.List();

const schemaSelector = createSelector(
  [
    state => state.cart.get("schema"),
    (state, props) => props.ctx.get("availableCards"),
    (state, props) => props.ctx.get("isMixedMourning"),
    (state, props) => props.t,
    (state, props) => props.ctx.get("isMourning"),
    (state, props) => formSelector(state, `recipients[${props.ctxIdx}].card.type`)
  ],
  (schema, availableCards, isMixedMourning, t, isMourning, selectedCardId) => {
    const isRibbon = selectedCardId === CARD_ID_RIBBON;

    const cardTextSchema = isRibbon
      ? schema.getIn(["properties", "recipients", "items", "properties", "card", "properties", "text", "oneOf", 1])
      : schema
          .getIn(["properties", "recipients", "items", "properties", "card", "properties", "text", "oneOf", 0])
          .setIn(["properties", "text", "maxLength"], 230);

    // console.log(cardTextSchema.toJS());
    return schema
      .setIn(["properties", "recipients", "items", "properties", "card", "properties", "text"], cardTextSchema)
      .setIn(
        ["properties", "recipients", "items", "properties", "card", "properties", "type", "enum"],
        !availableCards ? EMPTY_LIST : availableCards.map(c => c.get("id"))
      )
      .setIn(
        ["properties", "recipients", "items", "properties", "card", "properties", "type", "enum_titles"],
        !availableCards
          ? EMPTY_LIST
          : availableCards.map(c => `${c.get("title")} (${price(c.get("priceEx") * c.get("taxMultiplier"))})`)
      );
  }
);

export default translate()(
  connect((state, props) => ({
    isMourning: props.ctx.get("isMourning"),
    isMixedMourning: props.ctx.get("isMixedMourning"),
    selectedCardId: formSelector(state, `recipients[${props.ctxIdx}].card.type`),
    cardText: formSelector(state, `recipients[${props.ctxIdx}].card.text`),
    schema: schemaSelector(state, props)
  }))(CardDetails)
);
